import React, { useState, useEffect, useRef } from "react";
import "./settings-sidebar.css";

export default function SettingsSidebar({
                                            sessionId,
                                            createSession,
                                            leaveSession,
                                            handleChangeLayout,
                                            handleSwitchSide,
                                            toggleShowRadius,
                                            showRadius,
                                            toggleShowGrid,
                                            showGrid,
                                            showCaps,
                                            toggleShowCaps,
                                            showScore,
                                            toggleShowScore
                                        }) {
    const [isOpen, setIsOpen] = useState(false);
    // Detect mobile devices (for click instead of hover)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Create a ref to reference the sidebar container.
    const sidebarRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Listen for clicks outside the sidebar to close it.
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isOpen && sidebarRef.current && !sidebarRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    // Toggle sidebar function
    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    function onClickButton() {
        toggleSidebar();
    }

    return (
        <div
            id="settings-sidebar-container"
            ref={sidebarRef}
            onMouseEnter={!isMobile ? () => setIsOpen(true) : undefined}
            onMouseLeave={!isMobile ? () => setIsOpen(false) : undefined}
        >
            {/* Sidebar */}
            {isOpen && (
                <div id={isOpen ? "settings-sidebar-open" : "settings-sidebar"}>
                    <h3 id="settings-sidebar-title">Settings</h3>
                    <ul id="settings-menu">
                        { sessionId == null &&
                            <li onClick={() => {
                                setIsOpen(false);
                                createSession()
                            }}>
                                Create Session
                            </li>
                        }
                        { sessionId != null &&
                            <li onClick={() => {
                                setIsOpen(false);
                                leaveSession()
                            }}>
                                Leave Session
                            </li>
                        }
                        <li onClick={() => {
                            setIsOpen(false);
                            handleSwitchSide()
                        }}>
                            Change Faction
                        </li>
                        <li onClick={() => {
                            setIsOpen(false);
                            handleChangeLayout()
                        }}>
                            Change Layout
                        </li>
                    </ul>
                    <label id="toggle-label">
                        <span>Grid</span>
                        <input
                            type="checkbox"
                            checked={showGrid}
                            onChange={(e) => {
                                e.stopPropagation();
                                toggleShowGrid();
                            }}
                        />
                        <span className="slider"></span>
                    </label>
                    <label id="toggle-label">
                        <span>Caps</span>
                        <input
                            type="checkbox"
                            checked={showCaps}
                            onChange={(e) => {
                                e.stopPropagation();
                                toggleShowCaps();
                            }}
                        />
                        <span className="slider"></span>
                    </label>
                    <label id="toggle-label">
                        <span>Score</span>
                        <input
                            type="checkbox"
                            checked={showScore}
                            onChange={(e) => {
                                e.stopPropagation();
                                toggleShowScore();
                            }}
                        />
                        <span className="slider"></span>
                    </label>
                    <label id="toggle-label">
                        <span>Radius</span>
                        <input
                            type="checkbox"
                            checked={showRadius}
                            onChange={(e) => {
                                e.stopPropagation();
                                toggleShowRadius();
                            }}
                        />
                        <span className="slider"></span>
                    </label>
                </div>
            )}

            {/* Floating Toggle Button */}
            <div
                className={`floating-button`}
                onClick={onClickButton}
            >
                <img src="/icons/settings.svg" alt="Settings" className="gear-icon" />
            </div>
        </div>
    );
}
